module.exports = __webpack_public_path__ + "static/media/call-completed.f4e8094c.svg";